import * as React from 'react';
export var ActionsCard = React.forwardRef(function (_a, ref) {
    var opened = _a.opened, className = _a.className, title = _a.title, actions = _a.actions, children = _a.children, onHeaderClick = _a.onHeaderClick;
    var _b = React.useState(opened), open = _b[0], setOpen = _b[1];
    React.useEffect(function () {
        // open is not a dependency intentionally
        // we only care if opened change and look
        // at "open" at this point in time vs the
        // value of "opened"
        if (open !== opened) {
            setOpen(opened);
        }
    }, [opened]);
    return (React.createElement("div", { className: "feed-card ".concat(className || ''), ref: ref },
        React.createElement("div", { className: "feed-card-header", onClick: onHeaderClick },
            React.createElement("div", { className: "feed-card-header-title" }, title),
            React.createElement("div", { className: "feed-card-header-actions" },
                actions,
                React.createElement("a", { href: "#", title: open ? 'Collapse' : 'Expand', onClick: function (e) {
                        e.preventDefault();
                        setOpen(!open);
                    }, "aria-expanded": open },
                    React.createElement("i", { className: "fas fa-chevron-".concat(open ? 'up' : 'down') })))),
        React.createElement("div", { className: "collapse ".concat(open ? 'show' : 'hide') },
            React.createElement("div", { className: "feed-card-body" }, children))));
});
//# sourceMappingURL=index.js.map